// Morning & Mūn — Theme JS

// Scroll fade-up animation
document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));

  // Stagger children within grids
  document
    .querySelectorAll('.ingredients-grid, .testimonials-grid, .ritual-steps, .results-grid')
    .forEach((grid) => {
      grid.querySelectorAll('.fade-up').forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.1}s`;
      });
    });
});


// Contact form lightweight spam protection
document.addEventListener('DOMContentLoaded', function () {
  const contactForm = document.querySelector('form.contact-form');
  if (!contactForm) return;

  const loadedAtInput = contactForm.querySelector('#ContactFormLoadedAt');
  const honeypotInput = contactForm.querySelector('#ContactFormWebsite');
  const spamMessage = contactForm.querySelector('[data-contact-spam-message]');
  const loadedAt = Date.now();

  if (loadedAtInput) loadedAtInput.value = String(loadedAt);

  contactForm.addEventListener('submit', function (event) {
    const submittedTooFast = Date.now() - loadedAt < 3500;
    const honeypotFilled = honeypotInput && honeypotInput.value.trim() !== '';

    if (honeypotFilled || submittedTooFast) {
      event.preventDefault();
      if (spamMessage) spamMessage.hidden = false;
    }
  });
});

// Mobile hamburger menu
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header');
  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('#MobileHeaderMenu');

  if (!header || !toggle || !menu) return;

  function closeMenu() {
    header.classList.remove('mobile-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  function openMenu() {
    header.classList.add('mobile-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }

  toggle.addEventListener('click', function () {
    if (header.classList.contains('mobile-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  document.addEventListener('click', function (event) {
    if (!header.classList.contains('mobile-open')) return;
    if (header.contains(event.target)) return;
    closeMenu();
  });
});

// Advanced Treatments partner-link legal popup + persistent query strings
(function () {
  const storageKey = 'mmAdvancedTreatmentsPersistentQueryString';

  function persistCurrentQueryString() {
    if (window.location.search && window.location.search.length > 1) {
      try {
        window.sessionStorage.setItem(storageKey, window.location.search);
      } catch (error) {
        // Storage can be unavailable in some privacy modes. Links still work without persistence.
      }
    }
  }

  function getPersistentQueryString() {
    persistCurrentQueryString();

    try {
      return window.location.search || window.sessionStorage.getItem(storageKey) || '';
    } catch (error) {
      return window.location.search || '';
    }
  }

  function initAdvancedTreatmentConsent() {
    persistCurrentQueryString();

    const modal = document.querySelector('[data-advanced-treatment-modal]');
    const dialog = modal && modal.querySelector('.advanced-treatment-legal-modal__dialog');
    const confirmButton = modal && modal.querySelector('[data-advanced-treatment-modal-confirm]');
    const closeButtons = modal ? modal.querySelectorAll('[data-advanced-treatment-modal-close]') : [];
    const partnerLinks = document.querySelectorAll('[data-advanced-treatment-consent]');

    if (!modal || !confirmButton || !partnerLinks.length || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    let pendingUrl = '';

    function buildRedirectUrl(rawUrl) {
      if (!rawUrl) return '#';

      const persistentSearch = getPersistentQueryString();
      if (!persistentSearch || persistentSearch === '?') return rawUrl;

      try {
        const redirectUrl = new URL(rawUrl, window.location.origin);
        const persistentParams = new URLSearchParams(persistentSearch);

        persistentParams.forEach(function (value, key) {
          if (!redirectUrl.searchParams.has(key)) {
            redirectUrl.searchParams.append(key, value);
          }
        });

        return redirectUrl.toString();
      } catch (error) {
        const separator = rawUrl.indexOf('?') === -1 ? '?' : '&';
        return rawUrl + separator + persistentSearch.replace(/^\?/, '');
      }
    }

    function openModal(url) {
      pendingUrl = buildRedirectUrl(url);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('advanced-treatment-modal-open');
      if (dialog) dialog.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('advanced-treatment-modal-open');
      pendingUrl = '';
    }

    partnerLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(link.getAttribute('data-redirect-url') || link.getAttribute('href'));
      });
    });

    confirmButton.addEventListener('click', function () {
      if (!pendingUrl || pendingUrl === '#') {
        closeModal();
        return;
      }

      window.location.assign(pendingUrl);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAdvancedTreatmentConsent);
  document.addEventListener('shopify:section:load', initAdvancedTreatmentConsent);
})();
